/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentPointDecimalsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSIGNMENT_POINT_DECIMALS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AssignmentPointDecimalsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPointDecimalsSettingParser.decode(input).map(res => new AssignmentPointDecimalsSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentPointDecimalsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPointDecimalsSettingParser.encode(data);
    }
    static schema() {
        return AssignmentPointDecimalsSettingParser.schema();
    }
}
